import api from '@/services/api'
import endpoints from '@/services/endpoints'
import { Business, BusinessesResponse, CreateUpdateBusinessPayload } from '@/types/business'

const getBusinesses = async (page: number): Promise<BusinessesResponse> => {
  const response = await api.get(endpoints.BUSINESS.GET_BUSINESSES, {
    params: {
      page,
      sort: 'name',
    },
  })
  return response.data
}

const getBusiness = async (businessId: number) => {
  const response = await api.get(endpoints.BUSINESS.GET_BUSINESS.replace(':businessId', String(businessId)))
  return response.data
}

const createBusiness = async (payload: CreateUpdateBusinessPayload): Promise<Business> => {
  const response = await api.post(endpoints.BUSINESS.CREATE_BUSINESS, payload)
  return response.data
}

const updateBusiness = async (businessId: number, payload: CreateUpdateBusinessPayload): Promise<Business> => {
  const response = await api.patch(
    endpoints.BUSINESS.UPDATE_BUSINESS.replace(':businessId', String(businessId)),
    payload,
  )
  return response.data
}

export default {
  getBusinesses,
  getBusiness,
  createBusiness,
  updateBusiness,
}
